<template>
  <div class="mb-4 flex flex-col">
    <div class="flex justify-between items-center w-full">
      <label class="mr-4 font-semibold-x uppercase-x">
          Mostar esta sección
      </label>
      <b-switch v-model="form.visible" :disabled="!form.isUserManaged" size="small"/>
    </div>

    <div v-if="form && 'isEditable' in form" class="flex flex-col w-full mt-2 mb-2">
      <p class="mb-2">Personalize el código y nombre si es necesario</p>
      <div class="flex justify-between items-center w-full space-x-4">
        <div class="w-1/3">
          <b-field :label="$t('code')"
            :message="'Sin espacios'"
            :label-position="'inside'">
            <b-input v-model="form.code"
              :maxlength="10"
              :size="'is-small'"
              has-counter
              :disabled="form.code"
            ></b-input>
          </b-field>
        </div>
        <div class="w-2/3">
          <b-field :label="$t('name')" :message="'Nombre descriptivo descriptivo de la sección'"
            :label-position="'inside'"
          >
            <b-input v-model="form.name"
              :size="'is-small'"
              maxlength="25"
              has-counter
              :disabled="!form.visible"></b-input>
          </b-field>
        </div>
      </div>
    </div>

    <div v-if="form.hasAssociatedGroup" class="mt-2">
      <treeselect v-model="form.groupId" :options="getAvailableGroups"
        placeholder="Selecciona grupo asociado"
        :disabled="!form.visible"
      />
    </div>

    <div class="flex justify-between items-center w-full mt-2">
      <p class="mr-4">
          Cantidad de imagenes adicionales a mostrar
      </p>
      <b-numberinput v-model="form.numberOfExtraImages" min="0" max="10" icon-pack="fas"
        :disabled="!form.visible"
        size="is-small"
      >
      </b-numberinput>
    </div>

    <div class="flex justify-between items-center w-full mt-2">
      <span class="mr-4">
          Permitir al usuario habilitar o deshabilitar esta sección
      </span>
      <b-switch v-model="form.canDisableSection" size="is-small" :disabled="!form.visible" />
    </div>

    <!-- El tipo de documento no aplica a la sección GANTT (sus imágenes son
         capturas del Gantt, no un documento/plano), por eso se oculta ahí. -->
    <div class="flex justify-between items-center w-full mt-2" v-if="form && 'documentType' in form && form.code !== 'GANTT'">
      <span class="mr-4">
          Tipo de documento a mostrar como imagen principal
      </span>
      <b-select v-model="form.documentType" @input="(value) => { form.userCanDefineLegend = false; }">
        <option v-for="item in optionsDocumentTypes" :key="item.value" :value="item.value">
            {{ item.label }}
        </option>
      </b-select>
    </div>

    <div class="flex justify-between items-center w-full mt-2" v-if="form && 'documentType' in form">
      <span class="mr-4">
          {{ form.code === 'GANTT'
              ? 'Activar leyendas de color en las imágenes del Gantt'
              : 'Permitir al usuario definir leyendas del documento' }}
      </span>
      <b-switch v-model="form.userCanDefineLegend" size="is-small" :disabled="form.code !== 'GANTT' && !(form && 'documentType' in form)" />
    </div>

    <div class="flex justify-between items-center w-full mt-2" v-if="form.code === 'GANTT'">
      <span class="mr-4">
          {{ $t('gantt_page_orientation') }}
      </span>
      <b-select v-model="form.ganttLandscape" size="is-small" :disabled="!form.visible">
        <option :value="false">{{ $t('portrait') }}</option>
        <option :value="true">{{ $t('landscape') }}</option>
      </b-select>
    </div>

    <!-- Si está activo, el usuario ve y puede cambiar la orientación al generar; si no,
         se usa la orientación de arriba y la opción queda oculta en la generación. -->
    <div class="flex justify-between items-center w-full mt-2" v-if="form.code === 'GANTT'">
      <span class="mr-4">
          {{ $t('gantt_allow_user_change_orientation') }}
      </span>
      <b-switch v-model="form.ganttUserCanChangeOrientation" size="is-small" :disabled="!form.visible" />
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import { saveConfigSection } from '../services/report-detail.service.js';

export default {
  components: {
    Treeselect,
  },

  props: {
    initialData: {
      type: Object,
      required: true
    },
    activityGroups: {
      type: Array,
      default: () => []
    },
    reportConfigs: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      // defaults para configs guardadas antes de existir estos campos
      form: { ganttLandscape: false, ganttUserCanChangeOrientation: false, ...this.initialData },

      optionsDocumentTypes: [
          // { value: 'document', label: 'Documento' },
          { value: 'drawing', label: 'Plano' },
          { value: 'activity_document', label: 'Documento de actividad' },
          { value: null, label: 'Ninguno' }
      ],
    };
  },

  computed: {
    getAvailableGroups() {
      const selectedIds = this.reportConfigs.sections
          .filter((item) => item.id !== this.form.id && item.groupId)
          .map(item => item.groupId);

      const markDisabled = (nodes) => {
          return nodes.map(node => {
              const isCurrent = node.id === this.form.groupId;
              const disabled = !isCurrent && selectedIds.includes(node.id);
              const result = { id: node.id, label: node.label, isDisabled: disabled };
              if (node.children) {
                  result.children = markDisabled(node.children);
              }
              return result;
          });
      };

      return markDisabled(this.activityGroups);
    },
  },

  methods: {
    submit () {
      saveConfigSection(this.form, this.reportConfigs);
      this.$emit('epc-save', this.form);
    },

    // onGroupSelect(idx, newGroupId) {
    //   this.configs.sections.forEach((item, i) => {
    //       if (i !== idx && item.groupId === newGroupId) {
    //           item.groupId = null;
    //       }
    //   });
    //   this.configs.sections[idx].groupId = newGroupId;
    //   this.forceconfigsUpdate();
    // },

    // forceconfigsUpdate() {
    //   this.configs.sections = [...this.configs.sections];
    // },

    // este methodo lo dejamos algun momento se puede usar pora normalizar
    // :normalizer="treeselectNormalizer"
    treeselectNormalizer(n) {
      let node = {
        id: n.id,
        label: n.label,
        isDisabled: n.disabled || false,
      };

      if (Array.isArray(n.children) && n.children.length > 0) {
        node.children = n.children.map(this.treeselectNormalizer);
      }

      return node;
    },

  }
}
</script>